import React from 'react';
import { object, string } from 'yup';

import MESSAGES from '../../../locales';
import { Form, Input, Link, Button } from '../../_shared';

const ResetPasswordSchema = object().shape({
  password: string()
    .required(MESSAGES['password.presence'])
    .min(6, MESSAGES['password.minLength']),
  confirmPassword: string()
    .required(MESSAGES['password.presence'])
    .min(6, MESSAGES['password.minLength']),
});

const ResetPasswordForm = (props) => {
  return (
    <Form schema={ResetPasswordSchema} onSubmit={props.onSubmit}>
      <h3 className="mb-6 text-3xl text-center font-bold tracking-widest leading-7">
        {MESSAGES['resetPassword.title']}
      </h3>

      <Input
        id="password"
        name="password"
        label={MESSAGES['form.password']}
        type="password"
        required
      />
      <Input
        id="confirmPassword"
        name="confirmPassword"
        label="Confirm Password"
        type="password"
        required
      />
      {props.success && (
        <div className="text-green text-center text-sm mt-6">
          Reset password successfully! Please sign in.
        </div>
      )}
      {props.error && !props.success && (
        <div className="text-red text-center text-sm mt-6">{props.error}</div>
      )}
      <div className="flex flex-col mt-6">
        <Button
          className={`w-full font-semibold py-2 px-4 border border-solid rounded-lg text-white bg-primary`}
          type="primary"
          caption="Submit"
          busy={props.busy}
        />
      </div>
      <div className="mt-4 flex flex-col items-center">
        <Link
          className="mt-3 no-underline font-bold cursor-pointer text-black text-base"
          to="/sign-in"
        >
          {MESSAGES['form.action.returnToSignIn']}
        </Link>
      </div>
    </Form>
  );
};

export default ResetPasswordForm;
